<template>
  <div class="left-table-list">
    <div class="order-table-toolbar">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24" style="width: 100%">
            <div style="overflow: hidden;margin-top: 0px;display: flex" class="table-page-search-submitButtons">
              <j-super-query-new :commonSearch="commonSearch"
                                 saveCode="driverWorkorderTab"
                                 :fieldList="superFieldList" ref="superQueryModal"
                                 style="margin-left: 8px;" @handleSuperQuery="handleSuperQuery"
                                 @change="changeSuperQuery" v-show="false"></j-super-query-new>
              <div class="selected-count-bar" v-show="selectedRowKeys.length">
                <span class="count-text">已选择 {{ selectedRowKeys.length }} 项</span>
                <a-divider type="vertical" />
                <a type="text" @click="onClearSelected" class="clear-btn">
                  <icon-font  type="icon-shuaxin"></icon-font>
                  清空
                </a>
              </div>
              <div>
                <a-button type="primary" @click="newWorkOrder" icon="plus-circle"
                          style="height: 36px !important;border-radius: 18px;font-size: 14px">新建工单</a-button>
              </div>
              <div class="common-btn-box">
                <div class="common-btn-box-span" @click="clearSupper" v-show="!selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-shuaxin"></icon-font>
                  <span>重新加载</span>
                </div>
                <a-divider class="common-btn-divider" type="vertical" v-show="!selectedRowKeys.length"/>

                <div class="common-btn-box-span"  @click="batchZj(1,1)" v-show="selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-zhuanjiaogongdan"></icon-font>
                  <span>转交</span>
                </div>
                <a-divider class="common-btn-divider"  type="vertical" v-show="selectedRowKeys.length"/>
                <div class="common-btn-box-span"  @click="batchZj(4,4)" v-show="selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-guaqigongdan"></icon-font>
                  <span>挂起</span>
                </div>
                <a-divider class="common-btn-divider"  type="vertical" v-show="selectedRowKeys.length"/>
                <div class="common-btn-box-span" @click="batchClose" v-has="'workorder:all'" v-show="selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-jieshugongdanicon"></icon-font>
                  <span>结束</span>
                </div>
                <a-divider class="common-btn-divider"  type="vertical" v-has="'workorder:all'" v-show="selectedRowKeys.length"/>
                <div class="common-btn-box-span" @click="batchCq" v-has="'workorder:all'" v-show="selectedRowKeys.length">
                  <icon-font class="operate-btn-icon" type="icon-zhongqi"></icon-font>
                  <span>重启</span>
                </div>
                <a-divider class="common-btn-divider"  type="vertical" v-has="'workorder:all'" v-show="selectedRowKeys.length"/>
                <div class="common-btn-box-span" v-has="'workorder:del'" @click="batchDel" v-show="selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-shanchu-copy"></icon-font>
                  <span>删除</span>
                </div>
                <a-divider class="common-btn-divider" v-has="'workorder:del'" type="vertical" v-show="selectedRowKeys.length"/>
<!--                <div class="common-btn-box-span" @click="newWorkOrder"  v-show="!selectedRowKeys.length">-->
<!--                  <icon-font class="common-btn-icon" type="icon-xinzeng1"></icon-font>-->
<!--                  <span>新建工单</span>-->
<!--                </div>-->
<!--                <a-divider class="common-btn-divider"  type="vertical"  v-show="!selectedRowKeys.length"/>-->
                <div class="common-btn-box-span" @click="showSortTable"  v-show="!selectedRowKeys.length">
                  <icon-font class="common-btn-icon" type="icon-paixu"></icon-font>
                  <span>列表排序</span>
                </div>


              </div>

              <div class="car-more-box" v-if="dataSource && dataSource.length">
                <img :src="getFileAccessHttpUrl(dataSource[0].currTransferAvatar)" v-if="dataSource[0].currTransferAvatar"/>
                <span>{{dataSource[0].currTransferName}}</span>
                <span>更新于{{dataSource[0].updateTime}}</span>
              </div>
              <div class="car-more-box" v-else>

              </div>
            </div>
          </a-col>
        </a-row>
      </a-form>

    <div>
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :locale="tableLocale"
          :customHeaderRow="customHeaderRow"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          :customRow="customRow"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <span :slot="column.slots?column.slots.title:''"  v-for="column in columns">
          <slot :name="column.slots?column.slots.title:''">
              <span :style="{color: superQueryFieldMap[column.superName]?'#1890FF':''}">
              {{column.titleName}}
            </span>
            <icon-font :type="superQueryFieldMap[column.superName]?'icon-xialaxuanzeti-copy':'icon-xialaxuanzeti'" @click="searchSuper(column)"
                       style="cursor: pointer;width: 12px;"></icon-font>
          </slot>
        </span>
          <template :slot="column.scopedSlots?column.scopedSlots.customRender:''" slot-scope="text,record"  v-for="column in columns">
            <slot :name="column.scopedSlots?column.scopedSlots.customRender:''" v-bind="record" >

              <!--<div :style="{width: column.width?((column.width-20)+'px'):''}" class="table-div-text" :title="text" v-if="column.dataIndex!='workOrderStatus'">{{text}}</div>-->
              <div v-if="column.dataIndex=='workOrderStatus'">
                <span v-if="text==1 || text==4" style="color:#1890FF ">进行中</span>
<!--                <span v-if="text==4 " style="color:#1890FF ">挂起中</span>-->
                <span v-if="text==2" style="color: #91929e">已结束</span>
              </div>
              <div v-else-if="column.dataIndex=='carList'"  :style="{width: (column.width-20)+'px'}" class="table-div-text">
                <span  class="tb-span-click" :title="item.licensePlateNumber"  v-if="record.carList && record.carList.length" v-for="(item,idx) in record.carList" @click.stop="viewCar(record)">{{idx?(","+item.licensePlateNumber):item.licensePlateNumber}}</span>
                <span v-else>-</span>
              </div>
              <div v-else-if="column.dataIndex=='driverName'"  :style="{width: (column.width-20)+'px'}" class="table-div-text">
                <span v-if="record.tableDriverList">
                   <span :title="item.driverName" v-for="(item,idx) in record.tableDriverList"
                         :style="{color:item.driverLabelName?'#ff0000':''}">{{item.driverName}}{{(record.tableDriverList.length-1)>idx?',':''}}</span>
                </span>
              </div>
              <div v-else-if="column.dataIndex=='areaName'"  :style="{width: (column.width-20)+'px'}" class="table-div-text">
                <span v-if="record.tableDriverList">
                   <span :title="item.areaName" v-for="(item,idx) in record.tableDriverList"
                   >{{item.driverName}}（{{item.areaName}}）{{(record.tableDriverList.length-1)>idx?',':''}}</span>
                </span>
              </div>
              <div v-else-if="column.dataIndex=='driverLabel_dictText'"  :style="{width: (column.width-20)+'px'}" class="table-div-text">
                <span v-if="record.tableDriverList">
                   <span :title="filterDictTextByCache('driver_label',item.driverLabelName)" v-if="item.driverLabelName" v-for="(item,idx) in record.tableDriverList"
                   >{{item.driverName}}（{{filterDictTextByCache('driver_label',item.driverLabelName)}}）{{(record.tableDriverList.length-1)>idx?',':''}}</span>
                </span>
              </div>
              <div v-else-if="column.dataIndex=='updateTime'"  :style="{width: (column.width-20)+'px'}" class="table-div-text">
                <span >{{returnCallTime(record.createTime,null)}}</span>
              </div>
              <div v-else-if="column.dataIndex=='businessSegment_dictText'">
                <img v-if="record.logo" :title="text" :src="getImgView(record.logo)"  alt="" style="width:24px;height: 24px;font-size: 12px;font-style: italic;border-radius:3px"/>
                <span :style="{marginLeft: record.logo?'6px':''}">{{text || '-'}}</span>
              </div>
              <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text" v-else-if="column.dataIndex=='updateName'">
                 <span v-if="record.transferList&&record.transferList[0].createByAvatar" >
                  <img :title="record.transferList?record.transferList[0].createByName:'-'"
                       v-if="record.transferList[0].createByAvatar"
                       :src="getImgView(record.transferList[0].createByAvatar)"  height="20px" alt="" style="width:20px;font-size: 12px;font-style: italic;border-radius:50%"/>
                   <span style="width: 20px;display: inline-block" v-else></span>
                  <span style="margin-left: 10px" :title="text">{{text}}</span>
                 </span>
              </div>
              <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text" v-else>
               <span v-if="(column.dataIndex=='createByName') || (column.dataIndex=='transferName') || (column.dataIndex=='currTransferName')">
                <img :title="text"  v-if="(column.dataIndex=='createByName' && record.createByAvatar ) ||
                   (column.dataIndex=='currTransferName' && record.currTransferAvatar)
                   || (column.dataIndex=='transferName' && record.transferAvatar)" :src="getImgView((column.dataIndex=='createByName'?record.createByAvatar:(column.dataIndex=='currTransferName'?record.currTransferAvatar:record.transferAvatar)))" height="20px" alt="" style="width:20px;font-size: 12px;font-style: italic;border-radius:50%"/>
                   <span style="width: 20px;display: inline-block" v-else></span>
                 <span  style="margin-left: 10px">{{text || '-'}}</span>
               </span>
                <span :title="text" v-else>{{text || '-'}}</span>
              </div>

            </slot>
          </template>

        </a-table>
      </div>
    </div>
  <dm-zj-work-order-modal ref="realModal" @ok="loadData"></dm-zj-work-order-modal>
    <sort-table ref="sortTable" @ok="sortQuery"></sort-table>
    <workorder-modal-info ref="workorderModalInfo" @ok="loadData"></workorder-modal-info>
    <dm-work-order-modal ref="orderForm" @ok="loadData"></dm-work-order-modal>
  </div>

</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import {httpAction, getAction, getFileAccessHttpUrl} from '@/api/manage'
  import TopTabNew from "../TopTabNew";
  import DmZjWorkOrderModal from "@views/dm3/workorder/modules/DmZjWorkOrderModal";
  import SortTable from "@comp/dm/SortTable";
  import DmWorkOrderModal from "@views/dm3/workorder/modules/DmWorkOrderModal";
  import {returnCallTime} from "@/utils/util";
  import DmEmpty from "@/components/dm/empty/DmEmpty";
  export default {
    name: 'OrderTable',
    components: {
      DmWorkOrderModal, SortTable, DmZjWorkOrderModal, TopTabNew,
      WorkorderModalInfo: () => import('@views/dm5/WorkorderModalInfo')},
    mixins:[JeecgListMixin, mixinDevice],
    props: {
      driverId:{
        type:Number,
        default:''
      },
      formData:{
        type:Object,
        default:{}
      },
      model:{
        type:Object,
        default:{}
      }
    },data(){
      return {
        columns: [
          {
            titleName:'业务板块',
            align:"left",
            width:140,
            fixed:"left",
            dataIndex: 'businessSegment_dictText',
            scopedSlots: { customRender: 'businessSegment_dictTextSlot' },
            slots: { title: 'businessSegment_dictTextSpanSlot' },
            superName:"businessSegmentQuery",
            f:false
          },
          {
            titleName:'工单类型',
            align:"left",
            width:140,
            fixed:"left",
            dataIndex: 'typeName',
            scopedSlots: { customRender: 'typeNameSlot' },
            slots: { title: 'typeNameSpanSlot' },
            superName:"workOrderTypeQuery",
            f:false
          },
          {
            titleName: '工单状态',
            align:"left",
            width:140,
            fixed:"left",
            dataIndex: 'workOrderStatus',
            scopedSlots: { customRender: 'statusSlot' },
            slots: { title: 'workOrderStatusSpanSlot' },
            superName:"workOrderStatusQuery",
            f:false
          },{
            titleName:'转交人',
            align:"left",
            width:180,
            dataIndex: 'currTransferName',
            scopedSlots: { customRender: 'currTransferNameSlot' },
            slots: { title: 'currTransferQuerySpanSlot' },
            superName:"currTransferQuery",
            f:false
          },
          {
            titleName:'最新消息',
            align:"left",
            width:240,
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remarkSlot' },
            slots: { title: 'remarkSpanSlot' },
            superName:"remarkQuery",
            f:false
          },
          {
            titleName:'司机城市',
            align:"left",
            width:100,
            dataIndex: 'areaName',
            scopedSlots: { customRender: 'areaNameSlot' },
            slots: { title: 'areaNameSpanSlot' },
            superName:"areaName",
            f:false
          },
          {
            titleName:'司机',
            align:"left",
            width:180,
            color:'#1890FF',
            dataIndex: 'driverName',
            scopedSlots: { customRender: 'driverNameSlot' },
            slots: { title: 'driverNameSpanSlot' },
            superName:"driverNameQuery",
            f:false
          }

        ],defaultColumns: [
          {
            titleName:'司机',
            align:"left",
            width:140,
            color:'#1890FF',
            dataIndex: 'driverName',
            scopedSlots: { customRender: 'driverNameSlot' },
            slots: { title: 'driverNameSpanSlot' },
            superName:"driverNameQuery",
            f:false
          },
          {
            titleName:'业务板块',
            align:"left",
            width:140,
            dataIndex: 'businessSegment_dictText',
            scopedSlots: { customRender: 'businessSegment_dictTextSlot' },
            slots: { title: 'businessSegment_dictTextSpanSlot' },
            superName:"businessSegmentQuery",
            f:false
          },
          {
            titleName:'工单类型',
            align:"left",
            width:140,
            dataIndex: 'typeName',
            scopedSlots: { customRender: 'typeNameSlot' },
            slots: { title: 'typeNameSpanSlot' },
            superName:"workOrderTypeQuery",
            f:false
          },
          {
            title:'累计时长',
            align:"left",
            width:180,
            dataIndex: 'updateTime',
            scopedSlots: { customRender: 'updateTimeSlot' },
            slots: { title: 'updateTimeSpanSlot' },
            superName:"updateTimeQuery",
            f:false
          },
          {
            titleName: '工单状态',
            align:"left",
            width:100,
            dataIndex: 'workOrderStatus',
            scopedSlots: { customRender: 'statusSlot' },
            slots: { title: 'workOrderStatusSpanSlot' },
            superName:"workOrderStatusQuery",
            f:false
          },{
            titleName:'转交人',
            align:"left",
            width:180,
            dataIndex: 'currTransferName',
            scopedSlots: { customRender: 'currTransferNameSlot' },
            slots: { title: 'currTransferQuerySpanSlot' },
            superName:"currTransferQuery",
            f:false
          },{
            titleName:'创建人',
            align:"left",
            width:140,
            dataIndex: 'createByName',
            scopedSlots: { customRender: 'createByNameSlot' },
            slots: { title: 'createByNameSpanSlot' },
            superName:"createByQuery",
          },{
            titleName:'当前跟踪人',
            align:"left",
            width:140,
            dataIndex: 'transferName',
            scopedSlots: { customRender: 'transferNameSlot' },
            slots: { title: 'transferNameSpanSlot' },
            superName:"transferQuery",
            f:false
          },
          {
            titleName:'创建日期',
            align:"left",
            width:180,
            dataIndex: 'createTime',
            scopedSlots: { customRender: 'createTimeSlot' },
            slots: { title: 'createTimeSpanSlot' },
            superName:"createTimeQuery",
            f:false
          },
          {
            titleName:'最新消息',
            align:"left",
            width:240,
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remarkSlot' },
            slots: { title: 'remarkSpanSlot' },
            superName:"remarkQuery",
            f:false
          },
          {
            title:'车牌号',
            align:"left",
            width:180,
            dataIndex: 'carList',
            scopedSlots: { customRender: 'carSlot' }
          },
          {
            titleName:'司机城市',
            align:"left",
            width:100,
            dataIndex: 'areaName',
            scopedSlots: { customRender: 'areaNameSlot' },
            slots: { title: 'areaNameSpanSlot' },
            superName:"areaNameQuery",
            f:false
          },
          {
            titleName:'司机标签',
            align:"left",
            dataIndex: 'driverLabel_dictText',
            width:140,
            scopedSlots: { customRender: 'driverLabelSlot' },
            slots: { title: 'driverLabelSpanSlot' },
            superName:"driverLabelQuery",
            f:false
          }

        ],
        url: {
          list: "/dm/dmWorkOrder/list",
          delete: "/dm/dmWorkOrder/delete",
          deleteBatch: "/dm/dmWorkOrder/deleteBatch",
        },disableMixinCreated:true,
        hoverStr:'',
        activeKey:0,
        btnList:[
          {
            type:"1,4",
            name:"进行中",
            num:0
          },
          {
            type:"2",
            name:"已结束",
            num:0
          }
        ],
        commonSearch:[
          {
            type:1,
            title:"进行中",
            num:0,
            searchValue:[
              {
                text:"工单状态",
                valText:"进行中",
                rule:'eq'
              }
            ],
            isAll:true,
            queryParam:{
              type:-2,
              //typeStatus:'1,4'
            }
          },
          {
            type:1,
            title:"已结束",
            num:0,
            searchValue:[
              {
                text:"工单状态",
                valText:"已结束",
                rule:'eq'
              }
            ],
            queryParam:{
              type:-2,
              typeStatus:'2'
            }
          }
        ],
        superFieldList:[],
        menuTab:"driverWorkOrder",
        getFileAccessHttpUrl:getFileAccessHttpUrl,
        tableWidth:1080,
        parentList:[],
        windowHeight:window.innerHeight-356
      }
    },computed:{
      // 工单 TAB 空态定制：无工单时展示引导按钮
      tableLocale () {
        return {
          emptyText: this.$createElement(DmEmpty, {
            props: { scene: 'empty', bizName: '工单', action: '新建工单' },
            on: { action: this.newWorkOrder }
          })
        }
      }
    },methods:{
      returnCallTime,
      filterDictTextByCache,
     async loadList(){
        this.mrColumns = Object.assign([],this.columns);
        this.getCcList();
        this.getParentList();
        this.initParam();
        //this.queryParam.typeStatus = "1,4";
        this.queryParam.type =-2;
        this.commonSearch[0].num = this.formData.workorderIngCount;
        this.commonSearch[1].num = this.formData.workorderCount-this.formData.workorderIngCount
        try {
          await this.loadColumn();
        } catch (e) {
          console.error('加载列配置失败，使用默认列', e);
          if(!this.columns.length && this.defaultColumns){
            this.columns = Object.assign([], this.defaultColumns);
          }
        }
        this.loadData();
      },initParam(){
        this.queryParam = {};
        this.queryParam.driverId = this.driverId;
      },viewInfo(record){
        //this.$emit("showInfo",record.id,record.driverId,{f:"并联工单",s:'工单详情',page:'order',leftTab:3,fTable:3});
        this.$refs.workorderModalInfo.showInfo(record.id,{leftTab:1})
      },hoverA(a,b){
        this.hoverStr = a+""+b;
      },unHoverA(){
        this.hoverStr = ""
      },switchType(type,index){
        this.activeKey =index;
        this.queryParam.typeStatus =type
        this.loadData();
      },getImgView(text){
        if(text && text.indexOf(",")>0){
          text = text.substring(0,text.indexOf(","))
        }
        return getFileAccessHttpUrl(text)
      },
      getSuperFieldList(){//transferQuery
        let fieldList=[];
        fieldList.push({type:'string',defaultRule:"eq",showRule:{"eq":true,"like":true,"locate":true,"ne":true},value:'driverNameQuery',text:'客户姓名',dictCode:''})
        fieldList.push({type:'string',defaultRule:"eq",showRule:{"eq":true,"like":true,"locate":true,"ne":true},value:'remarkQuery',text:'最新消息',dictCode:''})
        fieldList.push({type:'string',showRule:{"eq":true,"is_null":true,"locate":true},defaultRule:'eq',value:'areaNameQuery',text:'所属城市'})
        fieldList.push({type:'sel_search',defaultRule:"eq",showRule:{"eq":true,"ne":true},value:'workOrderTypeQuery',text:'工单类型',options:this.parentList})
        fieldList.push({type:'int',defaultRule:"eq",showRule:{"eq":true},value:'businessSegmentQuery',text:'业务板块',dictCode:'business_segment'})
        fieldList.push({type:'int',defaultRule:"eq",showRule:{"eq":true},value:'workOrderStatusQuery',text:'工单状态',dictCode:'work_order_status'})
        fieldList.push({type:'date',defaultRule:"like",showRule:{"like":true},value:'createTimeQuery',text:'创建时间'})
        fieldList.push({type:'sel_search',defaultRule:"eq",showRule:{"eq":true},value:'transferQuery',text:'当前跟踪人',options:this.ccList})
        fieldList.push({type:'sel_search',defaultRule:"eq",showRule:{"eq":true},value:'currTransferQuery',text:'转交人',options:this.ccList})
        fieldList.push({type:'sel_search',defaultRule:"eq",showRule:{"eq":true},value:'createByQuery',text:'创建人',options:this.ccList})
        fieldList.push({type:'string',defaultRule:"eq",showRule:{"eq":true,"is_null":true},value:'driverLabelQuery',text:'司机标签',dictCode:'driver_label'})
        this.superFieldList = fieldList
      },
      getParentList(){
        this.parentList = [];
        getAction("/dm/dmWorkOrderType/listAll",{}).then(res=>{
          if(res.success){
            let list = res.result;
            if (list) {
              for (var k in list) {
                this.parentList.push({
                  text: list[k].name,
                  value: list[k].id
                });
              }

            }
          }
        });
      },
      getCcList(){
        var that =this;
        that.ccList = [];
        getAction("/sys/user/queryAllList",{"permissionId":"1543471348594860033",'all':true}).then((res)=>{
          if(res.success){
            let ccList = res.result;
            if(ccList){
              for(var k in ccList){
                that.ccList.push({
                  text:ccList[k].realname,
                  value:ccList[k].username
                });
              }

            }
            this.getSuperFieldList();
          }
        });
      },batchZj(t,workOrderStatus){
        if(this.selectedRowKeys.length>0){
          let workOrderId = "";
          let rowsMap = {}
          let isCreateBy = true;
          let backFlag = 1;
          for(var k in this.dataSource){
            rowsMap[this.dataSource[k].id] =this.dataSource[k];
          }
          for(let b in this.selectedRowKeys){
            let a = this.selectedRowKeys[b];
            if(t==1){
              if(rowsMap[a]&& rowsMap[a].workOrderStatus!=2){
                workOrderId+=","+a;
              }
            }
            if(t==4){
              if(rowsMap[a]&& rowsMap[a].workOrderStatus==1){
                workOrderId+=","+a;
              }
            }

            if(t==5){
              if(rowsMap[a]&& (rowsMap[a].workOrderStatus==1 || rowsMap[a].workOrderStatus==4)){
                workOrderId+=","+a;
              }
            }

            if(t==6){
              if(rowsMap[a]&& rowsMap[a].workOrderStatus==3){
                workOrderId+=","+a;
              }
            }
            if(isCreateBy&&!rowsMap[a].isCreateBy){
              isCreateBy = false;
            }
            if(backFlag==1 && rowsMap[a].backFlag!=1){
              backFlag = rowsMap[a].backFlag;
            }
          }
          if(workOrderId) {
            workOrderId = workOrderId.substr(1);
            let record = {
              ids: workOrderId,
              type: t,
              workOrderStatus:workOrderStatus,
              isCreateBy:isCreateBy,
              backFlag:backFlag
            }
            this.$refs.realModal.add(record);
            //this.$refs.realModal.add(arr);
          }else{
            if(t==1){
              this.$message.warning("请至少选择一个可转交的工单");
            }
            if(t==4){
              this.$message.warning("请至少选择一个可挂起的工单");
            }
            if(t==5){
              this.$message.warning("请至少选择一个进行中的工单");
            }

          }
        }else{
          this.$message.warning("请至少选择一个工单");
        }
      },batchCq(){
        if(this.selectedRowKeys.length>0){
          let workOrderId = "";
          let rowsMap = {}
          for(var k in this.dataSource){
            rowsMap[this.dataSource[k].id] =this.dataSource[k];
          }

          for(let b in this.selectedRowKeys){
            let a = this.selectedRowKeys[b];
            if(rowsMap[a] && rowsMap[a].workOrderStatus==2){
              workOrderId+=","+a;
            }
          }
          if(workOrderId){
            workOrderId = workOrderId.substr(1);
            let record = {
              ids:workOrderId,
              type:3,
              workOrderStatus:1
            }
            this.$refs.realModal.add(record);
          }else{
            this.$message.warning("请至少选择一个进行中的工单");
          }

          //this.$refs.realModal.add(arr);
        }else{
          this.$message.warning("请至少选择一个工单");
        }
      },batchClose(){

        if(this.selectedRowKeys.length>0){
          let workOrderId = "";
          let rowsMap = {}
          for(var k in this.dataSource){
            rowsMap[this.dataSource[k].id] =this.dataSource[k];
          }

          for(let b in this.selectedRowKeys){
            let a = this.selectedRowKeys[b];
            if(rowsMap[a] && rowsMap[a].workOrderStatus!=2){
              workOrderId+=","+a;
            }
          }
          if(workOrderId){
            workOrderId = workOrderId.substr(1);
            let record = {
              ids:workOrderId,
              type:2,
              workOrderStatus:2
            }
            this.$refs.realModal.add(record);
          }else{
            this.$message.warning("请至少选择一个进行中的工单");
          }

          //this.$refs.realModal.add(arr);
        }else{
          this.$message.warning("请至少选择一个工单");
        }

      },sortQuery(){
        location.reload();
      },showSortTable(){
        this.$refs.sortTable.show(this.columns,this.defaultColumns,this.menuTab, this.mrColumns);
      },newWorkOrder(){
        this.$refs.orderForm.add([this.model]);
      },
      handleSuperQuery(params, matchType,queryParam) {
        //高级查询方法
        if(params && params.length){
          this.superQueryFlag = true
          this.superQueryParams=JSON.stringify(params)
          this.superQueryMatchType = matchType
        }else{
          this.superQueryParams=''
          this.superQueryFlag = false
        }
        if(queryParam){
          if(queryParam.reload){
            this.initParam();
          }else{
            this.queryParam = {
              ...this.queryParam,
              ...queryParam
            }
          }

        }
        this.loadData()
      }
    }
  }
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
@import '~@assets/less/dm/tableList.less';
@import '~@assets/less/dm/newTable.less';
/deep/ th[key='selection-column']{
  padding: 12px 22px !important
}
.left-table-list{
  margin-top: 0 !important;
}
.car-more-box{
  width: 376px;
  background: #fff;
  border-radius: 18px;
  padding:7px 18px;
}
.car-more-box img{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  vertical-align: sub;
}
.car-more-box span{
  margin-left: 9px;
}
</style>